module.exports = __webpack_public_path__ + "img/menu-icon-customers.f2af68c8.svg";